module.exports = __webpack_public_path__ + "img/nt55-05-80-1.prt.2bcc2425.jpg";